import React from 'react';
import StatCard from './stat-card';
import { StatsCardsGridProps } from '../types';

const StatsCardsGrid: React.FC<StatsCardsGridProps> = ({
  leftCards,
  rightCards,
}) => {
  return (
    <div className="flex w-7/12 px-8 md:pl-0 sm:w-full sm:flex sm:px-0">
      <div className="flex flex-col w-1/2 items-center px-2 sm:px-0">
        {leftCards.map((card, index) => (
          <StatCard
            key={`left-${index}`}
            number={card.number}
            title={card.title}
            icon={card.icon}
            altText={card.alt_text}
          />
        ))}
      </div>
      <div className="flex flex-col justify-center sm:justify-start px-2 sm:px-0 items-center w-1/2">
        {rightCards.map((card, index) => (
          <StatCard
            key={`right-${index}`}
            number={card.number}
            title={card.title}
            icon={card.icon}
            altText={card.alt_text}
          />
        ))}
      </div>
    </div>
  );
};

export default StatsCardsGrid;
